import { gsap } from 'gsap';
import throttle from 'lodash/throttle';

const init = (rotatingSlides) => {
  const slideImages = rotatingSlides.querySelectorAll('.rotating-slides__image');
  const slideCopies = rotatingSlides.querySelectorAll('.rotating-slides__copy');
  const slideRingSegments = rotatingSlides.querySelectorAll('svg > g > path');

  // Keep track of active slide.
  const slideCount = slideImages.length;
  let activeIndex = 0;

  // Initialize styling.
  gsap.set(slideImages, { autoAlpha: 0 });
  gsap.set(slideImages[0], { autoAlpha: 1 });
  gsap.set(slideCopies, { autoAlpha: 0 });
  gsap.set(slideCopies[0], { autoAlpha: 1, display: 'block' });
  slideRingSegments[activeIndex].classList.add('active');

  const tl = gsap.timeline({ paused: true });
  Array.from(slideImages).forEach((image, i) => {
    tl
      .to(image, {
        autoAlpha: 1,
        duration: 0.2,
        onUpdate() {
          Array.from(slideRingSegments).forEach((ringSegment) => ringSegment.classList.remove('active'));
          slideRingSegments[activeIndex].classList.add('active');
        },
      })
      .to(slideCopies[i], { autoAlpha: 1, display: 'block', duration: 0.2 }, '<')
      .addLabel(`slide-${i}`)
      .to(image, { autoAlpha: 0, duration: 0.2 })
      .to(slideCopies[i], { autoAlpha: 0, display: 'none', duration: 0.2 }, '<')
      .addLabel(`slide-end-${i}`);
  });

  const goToSlide = throttle((index) => {
    activeIndex = ((index >= slideCount) || (index < 0)) ? 0 : index;

    if (activeIndex === 0) {
      tl.tweenFromTo(0, `slide-${activeIndex}`);
    } else {
      tl.tweenTo(`slide-${activeIndex}`);
    }
  }, 200);
  const nextSlide = () => {
    goToSlide(activeIndex + 1);
  };
  const prevSlide = () => {
    goToSlide(activeIndex - 1);
  };

  return {
    getActiveIndex: () => activeIndex,
    slideCount,
    nextSlide,
    prevSlide,
    goToSlide,
  };
};

export { init };
